module.exports = __webpack_public_path__ + "static/media/resultsGraphicPassed1_mobile.449fd39e.jpg";